"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

export default function PinGate({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  const [status, setStatus] = useState<"checking" | "locked" | "unlocked">("checking");
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch("/api/auth/status")
      .then((res) => res.json())
      .then((data) => setStatus(data.ok ? "unlocked" : "locked"))
      .catch(() => setStatus("locked"));
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pin }),
    });
    if (res.ok) {
      setStatus("unlocked");
    } else {
      setError(true);
      setPin("");
      setTimeout(() => setError(false), 1500);
    }
  }

  if (status === "checking") return null;
  if (status === "unlocked") return <>{children}</>;

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900/60 p-8 shadow-xl text-center">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-400">Restricted Access</p>
        <h1 className="mb-1 text-2xl font-semibold text-slate-50">{title}</h1>
        <p className="mb-6 text-sm text-slate-400">Enter your PIN to continue</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password" inputMode="numeric" maxLength={4} value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
            placeholder="• • • •"
            className={`w-full rounded-xl border ${error ? "border-red-500" : "border-slate-700"} bg-slate-800 px-4 py-3 text-center text-2xl font-mono tracking-[0.6em] text-slate-100 outline-none focus:border-sky-500 transition-colors`}
            autoFocus
          />
          {error && <p className="text-sm text-red-400">Incorrect PIN — try again</p>}
          <button type="submit" className="w-full rounded-xl bg-sky-500 px-4 py-3 text-sm font-semibold text-slate-950 transition hover:bg-sky-400 active:scale-95">
            Unlock
          </button>
        </form>
        <Link href="/" className="mt-6 block text-xs text-slate-500 hover:text-slate-400 transition-colors">
          ← Back to OliSense
        </Link>
      </div>
    </div>
  );
}
